// src/SplashScreen.tsx
import "./SplashScreen.css";

export default function SplashScreen() {
  return (
    <div className="splash-screen">
      <img src="/logo.png" alt="Logo" className="splash-logo" />
      <h1 className="splash-title">Games GPT</h1>
      <p className="splash-subtitle">Lancement en cours…</p>
    </div>
  );
}
